export default __webpack_public_path__ + "static/media/logisticchaos-logo.ef7eb1b6.jpg";